import React, { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Loading: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: '25%',
          left: '50%',
          transform: 'translate(-50%, -25%)',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress color="primary" size={60} />
        </Box>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: '32%',
          left: '50%',
          transform: 'translate(-50%, -32%)',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{ fontSize: '16px', lineHeight: '17px', fontWeight: '300' }}
        >
          {t('checking_address')}
        </Typography>
      </Box>
    </>
  );
};

export default Loading;
